// Mock data for Pinar English Academy

export const navLinks = [
  { label: 'Nosotros', href: '#nosotros' },
  { label: 'Cursos', href: '#cursos' },
  { label: 'Cambridge', href: '#cambridge' },
  { label: 'Método', href: '#metodo' },
  { label: 'Contacto', href: '#contacto' },
];

export const heroContent = {
  eyebrow: 'Inglés que se habla, se vive y se disfruta',
  titleLines: [
    { text: 'Learn it.', color: 'text-[#1E3A5F]', italic: false },
    { text: 'Speak it.', color: 'text-[#9B2C3B]', italic: true },
    { text: 'Love it.', color: 'text-[#B08D3C]', italic: true },
  ],
  description:
    'Un instituto donde chicos, jóvenes y adultos aprenden inglés hablando desde el primer día, con preparación oficial Cambridge en un ambiente cálido.',
  primaryCta: 'Inscribírme ahora',
  secondaryCta: 'Ver cursos',
  badge: 'CAMBRIDGE READY',
  cardTitle: 'NUESTRA ACADEMIA',
  cardSubtitle: 'Donde el inglés cobra vida',
  chip: 'Cambridge English',
  chipSub: 'preparación oficial',
  communityLabel: '+300 alumnos',
  communitySub: 'aprenden con nosotros',
};

export const aboutContent = {
  eyebrow: 'Sobre nosotros',
  title: 'Una academia abierta a nuevas',
  titleHighlight: 'oportunidades.',
  description:
    'En Pinar English Academy creemos que aprender inglés va mucho más allá de una clase. Acompañamos a cada alumno para que encuentre su propia voz en inglés, en un ambiente cercano y motivador.',
  bullets: [
    'Docentes que inspiran',
    'Preparación Cambridge',
    'Clases dinámicas',
    'Comunidad cercana',
  ],
};

export const courses = [
  {
    id: 'kids',
    name: 'Little Speakers',
    age: '5 a 11 años',
    color: '#E8B84A',
    text: '#1E3A5F',
    description:
      'Primeros pasos en inglés con juegos, canciones y mucho movimiento.',
    cta: 'Quiero saber más',
  },
  {
    id: 'teens',
    name: 'Young Explorers',
    age: '12 a 17 años',
    color: '#5B84A6',
    text: '#FFFFFF',
    description:
      'Clases activas para conversar, ganar confianza y rendir KET, PET o FCE.',
    cta: 'Quiero saber más',
  },
  {
    id: 'adults',
    name: 'Teens & Adults',
    age: 'Desde 18 años',
    color: '#9B2C3B',
    text: '#FFFFFF',
    description:
      'Inglés a medida para trabajar, viajar o certificar tu inglés avanzado. Preparación para IELTS y CAE.',
    cta: 'Quiero saber más',
  },
];

export const cambridgeContent = {
  eyebrow: 'CAMBRIDGE READY',
  title: 'Preparación oficial para',
  titleHighlight: 'Cambridge English.',
  description:
    'Somos centro preparador oficial. Nuestros alumnos rinden con excelentes resultados y obtienen certificaciones reconocidas en todo el mundo.',
  levels: [
    { code: 'A2', name: 'Key (KET)', desc: 'Nivel elemental' },
    { code: 'B1', name: 'Preliminary (PET)', desc: 'Nivel intermedio' },
    { code: 'B2', name: 'First (FCE)', desc: 'Intermedio alto' },
    { code: 'C1', name: 'Advanced (CAE)', desc: 'Avanzado' },
    { code: 'C2', name: 'Proficiency (CPE)', desc: 'Excelencia' },
  ],
  stats: [
    { value: '96%', label: 'aprobados 2024' },
    { value: '17', label: 'años de trayectoria' },
    { value: '300+', label: 'certificaciones' },
  ],
  cta: 'Consultar por exámenes',
};

export const methodValues = [
  {
    id: 'v1',
    icon: 'Mic',
    title: 'Oralidad primero',
    description:
      'Desde el primer día hablamos inglés. Perdés el miedo y ganás confianza.',
  },
  {
    id: 'v2',
    icon: 'Users',
    title: 'Grupos reducidos',
    description:
      'Máximo 10 alumnos por clase para que cada voz sea escuchada.',
  },
  {
    id: 'v3',
    icon: 'Sparkles',
    title: 'Progreso visible',
    description:
      'Objetivos claros y herramientas para celebrar cada pequeño avance.',
  },
];

export const featureQuote = {
  text: '"Cuando hablar inglés se vuelve natural, todo lo demás llega solo."',
  author: 'Equipo Pinar English',
  role: 'Desde 2008',
};

export const testimonials = [
  {
    id: 't1',
    color: '#F5DC9E',
    text:
      'Mi hijo rindió el KET y aprobó con distinción. El acompañamiento del profe fue clave.',
    author: 'Laura, mamá de Mateo',
  },
  {
    id: 't2',
    color: '#CFDDE8',
    text:
      'Empecé de cero por trabajo y hoy tengo el FCE. Los grupos pequeños hacen toda la diferencia.',
    author: 'Diego, alumno adulto',
  },
  {
    id: 't3',
    color: '#EBC9CE',
    text:
      'La preparación Cambridge es seria y a la vez motivadora. Mi hija está feliz.',
    author: 'Cecilia, mamá de Julia',
  },
];

export const contactInfo = {
  eyebrow: 'HABLEMOS',
  titleLine1: 'Tu próxima historia',
  titleLine2: 'en inglés empieza',
  titleLine3End: 'pregunta.',
  titleLine3Start: 'con una',
  description:
    'Contanos qué buscás y te asesoramos sobre el curso ideal. Respondemos en menos de 24 horas hábiles.',
  address: 'Perez Butler manzana 213B solar 16 esquina Santa Paula',
  phone: '099 200 180',
  email: 'pinarenglishacademy@gmail.com',
  hours: 'Lun a Vie · 9 a 18 hs · Sáb · 9 a 13 hs',
  whatsappCta: 'Escribinos por WhatsApp',
  whatsappNumber: '59899200180',
  formTitle: 'Contanos sobre vos',
  formSub: 'Te respondemos en menos de 24 horas',
  interests: [
    'Elegí un curso',
    'Inglés niños (5-11)',
    'Inglés jóvenes (12-17)',
    'Inglés adultos',
    'Preparación Cambridge',
    'Clases 1:1',
    'Aún no lo sé',
  ],
  submitCta: 'Quiero inscribirme',
};

export const footerContent = {
  brand: 'Pinar English Academy',
  tagline: 'Learn it. Speak it.',
  legal: '© 2025 Pinar English Academy',
  meta: 'Centro preparador oficial Cambridge',
};
